export default {
  CHECKBOX: 'checkbox',
  RADIO: 'radio',
  PASSWORD: 'password',
  TEXT: 'text',
}